import "@/styles/globals.css";
import type { AppProps } from "next/app";
import Script from "next/script";

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Script
        src="https://umami.manuel-ramsaier.com/script.js"
        data-website-id="ba1222d8-73eb-48be-912a-4c4d8c7523e1"
        strategy="afterInteractive"
      />
      <Component {...pageProps} />
    </>
  );
}
